import api from "../../../../../../../services/api";

// Lista todos os templates globais de diagrama (ordenação por createdAt desc vem do backend)
export const fetchDiagramaTemplates = async () => {
  const response = await api?.post?.("/interno/findMany/templateDiagrama");
  return response?.data || [];
};

// Cria um template a partir do diagrama atual já sanitizado
export const createDiagramaTemplate = async ({
  nome,
  descricao,
  dados,
} = {}) => {
  const response = await api?.post?.("/interno/create/templateDiagrama", {
    nome,
    descricao,
    dados,
  });
  return response?.data;
};

// Renomea ou edita a descrição de um template (dados nunca mudam por aqui)
export const updateDiagramaTemplate = async ({ id, nome, descricao } = {}) => {
  const response = await api?.post?.("/interno/update/templateDiagrama", {
    id,
    nome,
    descricao,
  });
  return response?.data;
};

// Remove um template (hard delete)
export const deleteDiagramaTemplate = async (id) => {
  await api?.post?.("/interno/delete/templateDiagrama", { id });
};

// Aplica um template em vários circuitos do cliente numa única transação no backend
export const applyManyDiagramaTemplate = async ({
  templateId,
  circuitoIds = [],
  novosCircuitos = [],
} = {}) => {
  const response = await api?.post?.("/interno/applyMany/templateDiagrama", {
    templateId,
    circuitoIds,
    novosCircuitos,
  });
  return response?.data;
};
